import moment from 'moment';

export default function momentSecondsSince(date: Date) {
  if (!date) {
    return '';
  }

  return moment().diff(date, 'seconds');
}
